module.exports = __webpack_public_path__ + "static/Wiki_Tiles_P-IN-2905_white-75027c0334ed1079bc08e867644a87c1.png";